function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var Times = function Times(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    width: 8,
    height: 8
  }, props), React.createElement("defs", null, React.createElement("path", {
    d: "M4.848 4l2.564-2.564.53-.529a.2.2 0 0 0 0-.282L7.374.059a.2.2 0 0 0-.282 0L4 3.152.907.058a.2.2 0 0 0-.282 0L.058.624a.2.2 0 0 0 0 .283L3.152 4 .058 7.093a.2.2 0 0 0 0 .282l.566.566a.2.2 0 0 0 .283 0L4 4.848l2.564 2.564.529.53a.2.2 0 0 0 .282 0l.566-.567a.2.2 0 0 0 0-.282L4.848 4z",
    id: "times_svg__a"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("mask", {
    id: "times_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#times_svg__a"
  })), React.createElement("g", {
    mask: "url(#times_svg__b)",
    fill: "#FFF"
  }, React.createElement("path", {
    d: "M0 0h8v8H0z"
  }))));
};

export default Times;